import React from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import Check from "../../assets/icon/svgs/check.svg";
import Checked from "../../assets/icon/svgs/checkTrue.svg";

type SelectWithPlaceHolderProps = {
  selectValues?: { name: string; value: string }[];
  selectValue: string;
  onSelectChange: (value: string) => void;
  placeholder?: string;
  size?: "sm" | "md" | "lg";
  manyChoices?: boolean;
};

export const SelectWithPlaceHolder: React.FC<SelectWithPlaceHolderProps> = ({
  selectValues,
  selectValue,
  onSelectChange,
  placeholder,
  size,
  manyChoices = true,
}) => {
  const { t } = useTranslation();
  const handleSelect = (value: string) => {
    if (onSelectChange) {
      onSelectChange(value);
    }
  };

  const selectedCountry = selectValues?.find(
    (item) => item.value === selectValue
  );

  return (
    <Select value={selectValue} onValueChange={handleSelect}>
      <SelectTrigger
        className={`w-full border-2 border-gray-300 rounded-[8px] px-4 text-[20px]  ${
          selectValue ? "text-black" : "text-neutral-500"
        } ${
          size === "sm"
            ? "h-[36px] w-[82px] text-[12px] px-[12px] py-[10px]"
            : size === "md"
            ? "h-[50px]"
            : "h-[60px]"
        }`}
        id="select_country"
        placeHolderCustom={placeholder ? t(placeholder) : ""}
        value={selectValue}
      >
        <SelectValue
          data-overflow="true"
          id="select_counry_option"
          placeholder={placeholder ? t(placeholder) : ""}
        >
          {selectedCountry && selectedCountry.name}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="w-full border-2 border-gray-300 rounded-[8px]">
        {selectValues?.map((item) => (
          <SelectItem
            key={item.value}
            value={item.value}
            className="text-[16px]"
          >
            <div className="flex items-center gap-1">
              {manyChoices && (
                <img
                  src={selectValue === item.value ? Checked : Check}
                  alt="icon"
                  className="w-5 h-5"
                />
              )}
              {item.name}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
